import { render, staticRenderFns } from "./batchRemove.vue?vue&type=template&id=0b273cc0&scoped=true&"
import script from "./batchRemove.vue?vue&type=script&lang=js&"
export * from "./batchRemove.vue?vue&type=script&lang=js&"
import style0 from "./batchRemove.vue?vue&type=style&index=0&id=0b273cc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b273cc0",
  null
  
)

export default component.exports